<template>
	<table class="upload-pagination">
		<tr>
			<td class="beforeButton tableButton">
				<button class="buttonBefore buttonnav" v-if="before" @click="emitGoPage(page - 1)"><span class="arrow">⇐</span> Anterior</button>
			</td>
			<td class="pageSection tableButton">
				Página: {{ page + 1}}
			</td>
			<td class="afterButton tableButton">
				<button class="buttonAfter buttonnav" v-if="after" @click="emitGoPage(page + 1)">Siguiente <span class="arrow">⇒</span></button>
			</td>
		</tr>
	</table>
</template>


<script>
export default {
	name: "UploadsPagination",
	props: {
		page: {
			type: Number,
			required: true,
		},
		before: {
			type: Boolean,
			required: true,
		},
		after: {
			type: Boolean,
			required: true,
		},
	},
	methods: {
		emitGoPage(page) {
			// Emit an 'update-page' event with the new page number
			this.$emit('update-page', page);
		}
	},
};
</script>
<style scoped lang="scss">
.upload-pagination {
	text-align: center;
	width: 100%;
	font-family: var(--ap-font);
}

.tableButton {
	width: 10em;
}

.buttonnav {
	padding: 6px 14px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	background-color: var(--ap-paper);
	color: var(--ap-ink-2);
	font-weight: 600;
	font-size: 0.85em;
	cursor: pointer;
	transition: transform 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease),
		color 0.14s var(--ap-ease), background-color 0.14s var(--ap-ease);

	&:hover {
		transform: translateY(-2px);
		border-color: var(--ap-teal);
		color: var(--ap-teal-deep);
		background-color: var(--ap-mist);
	}

	&:active {
		transform: translateY(1px);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}

	&:disabled {
		border-color: var(--ap-line);
		color: var(--ap-muted);
		background-color: var(--ap-mist);
		cursor: not-allowed;
		transform: none;
	}
}

.pageSection {
	font-size: 0.8em;
	padding-top: 0.3em;
	color: var(--ap-muted);
}

.arrow {
	font-size: 1.2em;
	top: -1px;
	position: relative;
}
</style>
